import React from 'react'
import { ImageModalProvider } from './src/store/ImageModalContext'

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => {
  return <ImageModalProvider>{element}</ImageModalProvider>
}
